import { useRef } from 'react';
import { UploadInput } from './UploadInput';

// https://medium.com/web-dev-survey-from-kyoto/how-to-customize-the-file-upload-button-in-react-b3866a5973d8

type TProps = {
  Button: any;
  handleFiles: (files: File[]) => void;
  accept?: string;
  multiple?: boolean;
  [x: string]: any;
};

const UploadButton = ({ Button, handleFiles, accept = undefined, multiple = false, ...props }: TProps) => {
  const hiddenFileInput = useRef<HTMLInputElement | null>(null);

  const handleClick = () => {
    setTimeout(() => {
      if (hiddenFileInput.current) {
        hiddenFileInput.current.click();
      }
    }, 100);
  };

  return (
    <>
      <Button {...props} onClick={handleClick} />
      <UploadInput hiddenFileInput={hiddenFileInput} handleFiles={handleFiles} accept={accept} multiple={multiple} />
    </>
  );
};

export { UploadButton };
